import { Component, Input, OnInit } from '@angular/core';
import { Block, BlockStyle } from 'src/app/models/block.model';

@Component({
  selector: 'app-fakeloader',
  templateUrl: './fakeloader.component.html',
  styleUrls: ['./fakeloader.component.scss'],
})
export class FakeloaderComponent implements OnInit {
  @Input() block: Block;
  @Input() style: BlockStyle;
  constructor() {}

  ngOnInit(): void {}
}
